function Filemanager_form_delete(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
		filterDecoratorFilemanager: '.js-filter-decorator-filemanager'
    };

    this.triggers = {
	    beforeSubmit: 'i4:beforeSubmit',
		submitAjaxSuccess: 'i4:submitAjaxSuccess',
		updateFilter: 'i4:updateFilter'
    };

    this.init = function() {
        this.popup = i4_Popup.get(this.$element);

        this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$filterDecoratorFilemanager = $(this.selectors.filterDecoratorFilemanager);

	    this.$formParent.on(this.triggers.beforeSubmit, (function() {
		    i4_Popup.show_loader();
		    this.popup.hide();
	    }).bind(this));

		this.$formParent.on(this.triggers.submitAjaxSuccess, (function() {
            i4_Popup.remove_all();
			this.$filterDecoratorFilemanager.trigger(this.triggers.updateFilter);
        }).bind(this));

    };
}
